import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { TranslateWithDatePipe } from 'projects/tools/src/lib/shared-module/helpers/translate-with-date.pipe';

@Component({
  selector: 'lib-app-print-info',
  templateUrl: './print-info.component.html',
  styleUrls: ['./print-info.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, TranslateWithDatePipe],
})
export class PrintInfoComponent {}
